export class RespuestaUser {
    constructor(
        public codPregunta = 0,
        public tipo: string = '',
        public respuesta: string = ''

    ) {}
}

